module.exports = __webpack_public_path__ + "img/IT0000643854871.c30f36f4.png";